import { OfferingOption } from '@css-xp/base';
import { GetOrderPreviewDto, ProcessingInfo } from '@atlassian/cssxp-ccp-types';
import { EntitlementDetails, LinkedDestinationEntitlement } from '@css-xp/graphtypes/src/generated-types-new';
import { TransitionTime } from '@atlassian/cssxp-typescommon';
import { isImmediateAmendmentToFreeOrder } from '../manage-entitlement-helper';
import { FormState, OrderPreviewData } from '../manage-entitlement-v2';

export const validateOrderPreviewDetails = (data: OrderPreviewData['response']) => {
  if (data && data.items?.length > 0) {
    let allOrderTransitionsSame = true;

    data?.items?.reduce((acc, value) => {
      const transitionTime = value.processingInfo?.transitionTime;

      if (!transitionTime || transitionTime !== acc) {
        allOrderTransitionsSame = false;
      }

      return transitionTime;
    }, data?.items?.[0]?.processingInfo?.transitionTime);

    if (!allOrderTransitionsSame) {
      return 'Orders transition time can either be immediate only or scheduled only.';
    }

    return null;
  }
  return null;
};

export const formatOrderPreviewResponse = (
  data: OrderPreviewData['response'],
  formState: FormState,
  entitlement: EntitlementDetails,
  linkedEntitlements: LinkedDestinationEntitlement[]
) => {
  if (linkedEntitlements?.length > 0) {
    linkedEntitlements.forEach((ent) => {
      const orderPreviewDetail = data?.items?.find(
        (item) => item.processingInfo?.entitlement?.id === ent?.entitlementId
      );
      if (
        !orderPreviewDetail &&
        isImmediateAmendmentToFreeOrder(ent, formState[ent?.entitlementId]?.offering as OfferingOption)
      ) {
        data?.items?.push({
          processingInfo: {
            entitlement: {
              id: ent?.entitlementId,
            },
            transitionTime: TransitionTime.IMMEDIATE,
          },
        } as GetOrderPreviewDto['items'][0]);
      }
    });
  }

  const currentEntOrderPreviewDetail = data?.items?.find(
    (item) => item.processingInfo?.entitlement?.id === entitlement?.id
  );
  if (
    !currentEntOrderPreviewDetail &&
    isImmediateAmendmentToFreeOrder(entitlement, formState?.offering as OfferingOption)
  ) {
    data = {
      ...(data ?? {}),
      items: [
        ...(data?.items ?? []),
        {
          processingInfo: {
            entitlement: {
              id: entitlement?.id,
            },
            transitionTime: TransitionTime.IMMEDIATE,
          },
        },
      ],
    } as GetOrderPreviewDto;
  }

  return data;
};

export const getOrderPreviewMessage = (transitionTime: TransitionTime | undefined) => {
  if (transitionTime) {
    switch (transitionTime) {
      case TransitionTime.IMMEDIATE:
        return 'Amendments to this subscription will be immediate.';
      case TransitionTime.NEXT_CYCLE:
      case TransitionTime.SCHEDULED:
        return 'Amendments to this subscription will be scheduled to take effect at the next bill date.';
      default:
        return `Invalid transition time - ${transitionTime}`;
    }
  }

  return '';
};
